import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class GhostOwnershipInfoDeleteService {

  constructor(private http: HttpClient) { }

  /**
   * Delete ghost ownership payment
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param paymentData Payment data to delete
   * @param globalParams Global parameters from GlobalService
   * @param clobSettings CLOB settings object
   * @param rowData Row data from grid
   * @returns Observable with API response
   */
  deletePayment(
    baseUrl: string,
    paymentData: any[],
    globalParams: any,
    clobSettings: any[],
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=1bgh7g";
    
    // Build params following AngularJS pattern
    let params: any = {};
    params = _.merge({}, globalParams || {});
    
    // Add essential parameters from paymentData
    params.sso_id = clobSettings[0]?.sso_id || '';
    params.filing_key = paymentData[0]?.filing_key || '';
    params.ghost_scenario = paymentData[0]?.ghost_scenario || '';
    params.ho_leid = paymentData[0]?.ho_leid || '';
    params.ho_cdr_no = paymentData[0]?.ho_cdr_no || '';
    params.parent_leid = paymentData[0]?.parent_leid || '';
    params.parent_cdr_no = paymentData[0]?.parent_cdr_no || '';
    params.begin_date = paymentData[0]?.begin_date || '';
    
    // Convert to URL encoded format (AngularJS compatible)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { 
      headers, 
      withCredentials: true 
    });
  }
}

